// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"DocumentsListTab_buttonLink__2k8wc DataTable_buttonLink__3ec1z"};